"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../constants/index.js");
var _index2 = require("../../helpers/index.js");
var UUID = _index.localStorageKeys.UUID;
var uuidCleanup = function uuidCleanup(event) {
  var cookies = document.cookie;
  if (cookies.includes('uuid=')) document.cookie = 'uuid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  var localStorageUUID = localStorage.getItem(UUID);
  if (!(0, _index2.validateUserAccountID)(localStorageUUID)) localStorage.removeItem(UUID);
  return event;
};
var _default = exports["default"] = uuidCleanup;